<template>
  <div class="ai-right-operation-component">
    <div
      class="right-operation-wrap"
      :class="{
        'is-electron': isElectron,
      }"
    >
      <div class="cont-wrap">
        <button
          v-if="getShowToolbarVisible()"
          @click="handleToggle"
          class="toggle-btn"
        >
          <i v-if="isShow" class="el-icon-arrow-right" />
          <i v-else class="el-icon-arrow-left" />
        </button>
        <div
          class="right-operation-cont"
          :class="{
            'is-show': isShow,
          }"
          :style="handleContStyle"
        >
          <div class="top-operate">
            <div class="operate-item generate-note" @click="handleGenerateNote">
              <img src="../../../assets/images/course-card/note.png" alt="" />
              <span>生成笔记</span>
            </div>
            <div class="operate-item find-cont" @click="handleSearchContent">
              <img
                src="../../../assets/images/course-card/search-1.png"
                alt=""
              />
              <span>查找内容</span>
            </div>
          </div>
          <RetryableWrapper
            class="bottom-wrap"
            :status="status"
            :refreshFn="refreshFn"
          >
            <notes
              ref="notes"
              class="notes-component"
              :lessonInfo="lessonInfo"
              :componentId="'ai-mode-note'"
              @loadFail="onLoadFail"
            />
            <!-- <course-card
              class="course-card-component"
              :lesson-info="lessonInfo"
              :course-info="courseInfo"
              :activeTab="activeTab"
              :justShowTabList="true"
              :havePrivateLesson="courseInfo?.havePrivateLesson || 0"
            ></course-card> -->
            <generate-notes
              class="generate-notes-component"
              :class="{
                'is-show': showGenerateNotes,
              }"
              :lesson-info="lessonInfo"
              :visible="showGenerateNotes"
              @closeDrawer="closeGenerateNotes"
              @addToNote="onAddToNote"
            ></generate-notes>
          </RetryableWrapper>
          <search-dialog
            ref="searchDialog"
            class="search-dialog"
            @playCurNode="handlePlayCurNode"
          />
        </div>
      </div>
    </div>
    <!-- 占位元素 -->
    <div
      v-if="isElectron"
      class="right-operation-cont"
      :class="{
        'is-show': isShow,
      }"
      :style="handleContStyle"
    ></div>
  </div>
</template>

<script>
import Notes from "../components/Notes.vue";
import SearchDialog from "./SearchDialog.vue";
import { RetryableWrapper } from "@saas/components/src";
import GenerateNotes from "./GenerateNotes.vue";
import CourseCard from "../components/CourseCard.vue";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  props: {
    videoPlayerBoxHeight: {
      type: Number,
      default: 0,
    },
    justShowTabList: {
      type: Boolean,
      default: false,
    },
    lessonInfo: {
      type: Object,
      default: () => {},
    },
    courseInfo: {
      type: Object,
      default: () => {},
    },
    activeTab: {
      type: String,
      default: "desc",
    },
    havePrivateLesson: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isShow: true,
      status: "success",
      isElectron: window.isElectron,
      showGenerateNotes: false,
    };
  },
  components: {
    RetryableWrapper,
    GenerateNotes,
    // CourseCard,
    SearchDialog,
    Notes,
  },
  mounted() {},
  methods: {
    onLoadFail() {
      this.status = "error";
    },
    refreshFn() {
      this.status = "success";
      this.$nextTick(() => {
        console.log(this.$refs);
        this.$refs.notes.getNote();
      });
    },
    handlePlayCurNode(time) {
      this.$emit("playCurNode", time);
    },
    handleToggle() {
      this.isShow = !this.isShow;
      if (this.$refs.notes && !this.isShow) {
        this.$refs.notes.onClickSave(false);
      }
    },
    // 生成笔记啊
    handleGenerateNote() {
      if (this.showGenerateNotes) {
        return;
      }
      this.showGenerateNotes = true;
      if (this.$refs.notes && this.showGenerateNotes) {
        this.$refs.notes.onClickSave(false);
      }
    },
    // 查找内容
    handleSearchContent() {
      this.$refs.searchDialog.openDialog();
      this.handleSaveNote();
    },
    // 关闭生成笔记抽屉
    closeGenerateNotes() {
      this.showGenerateNotes = false;
      this.handleSaveNote();
    },
    onAddToNote(data) {
      this.showGenerateNotes = false;
      if (data.type === 1) {
        // 问答
        EventBus.$emit("handle-insert-qa-block-ai-mode-note", data);
      } else {
        // 总结视频
        const html = data.answer;
        EventBus.$emit("handle-insert-html-ai-mode-note", html);
      }
      this.$nextTick(() => {
        this.handleSaveNote(true);
      });
    },
    // 保存笔记
    handleSaveNote(isAi = false) {
      if (this.$refs.notes) {
        this.$refs.notes.onClickSave(false, null, isAi);
      }
    },
    getShowToolbarVisible() {
      if (this.showGenerateNotes) {
        return false;
      } else if (
        this.$refs.searchDialog &&
        this.$refs.searchDialog.dialogVisible
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  computed: {
    handleContStyle() {
      if (this.videoPlayerBoxHeight) {
        return {
          height: `${this.videoPlayerBoxHeight + 60}px`, //+ 25 + 170
        };
      } else {
        return {};
      }
    },
  },
};
</script>

<style scoped lang="scss">
$rightContentWidth: 340px;
.ai-right-operation-component {
  .right-operation-wrap {
    position: relative;
  }
  padding-left: 22px;
  .toggle-btn {
    position: absolute;
    top: 50%;
    left: -30px;
    transform: translateY(-50%);
    width: 30px;
    height: 90px;
    background: rgba(244, 252, 247, 0.9);
    border-radius: 8px 0px 0px 8px;
    border: 1px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 18px;
      color: #0d1400;
      font-weight: bold;
    }
  }
  .right-operation-cont {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 0;
    height: 100%;
    transition: width 0.3s ease;
    overflow: hidden;
    &.is-show {
      width: $rightContentWidth;
    }
  }
  .search-dialog {
    position: absolute;
    top: 79px;
    left: 0;
    right: 0;
  }
  .top-operate {
    width: $rightContentWidth;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .operate-item {
      width: 164px;
      height: 70px;
      background: rgba(244, 252, 247, 0.8);
      border-radius: 6px;
      border: 1px solid #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      &:hover {
        background: transparent;
      }
      img {
        margin-top: 14px;
        width: 21px;
        height: 21px;
      }
      span {
        margin-top: 10px;
        line-height: 17px;
        font-weight: 400;
        font-size: 12px;
        color: #0d1400;
        margin-bottom: 8px;
      }
    }
  }
  .bottom-wrap ::v-deep {
    width: $rightContentWidth;
    flex: 1;
    height: 0;
    & > div {
      height: 100%;
      position: relative;
      overflow: hidden;
    }
    .notes-component {
      padding: 0;
    }
    .generate-notes-component {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 100%;
      top: 0;
      transition: left 0.3s ease;
      overflow: hidden;
      &.is-show {
        left: 0;
      }
    }
  }

  // 客户端
  .is-electron {
    height: calc(100vh - 70px);
    position: fixed;
    right: 0;
    // padding-left: 22px;
    padding-right: 8px;
    z-index: 9;
    .cont-wrap {
      height: calc(100vh - 70px);
    }
  }
}
.course-card-component {
  margin-left: 0;
}
</style>
